import React, {useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import CopyTradingFeeData from '../../../features/page/copyTrading/fee/CopyTradingFeeData'
import CopyTradingMonthlyData from '../../../features/page/copyTrading/fee/CopyTradingMonthlyData'
import WizSelectButton from '../../../components/button/WizSelectButton'

interface IProps {
    className?: string
}

const CopyTradingFee: React.FC<IProps> = ({className}) => {
    const [view, setView] = useState('data')

    const selectData = [
        {id: 'data', value: 'Data'},
        {id: 'history', value: 'History'},
    ]

    return (
        <PageLayout title={'CopyTrading Fee'} className={className}>
            <article className={'mt-[30px] p-[20px]'}>
                <WizSelectButton
                    className={'mb-[20px]'}
                    onChange={e => {
                        setView(e?.id)
                    }}
                    data={selectData}
                    activeValue={selectData?.find(item => item.id === view)}
                />
                {view === 'data' && <CopyTradingFeeData />}
                {view === 'history' && <CopyTradingMonthlyData />}
            </article>
        </PageLayout>
    )
}

export default CopyTradingFee
